import { MagicTableCell, MagicTableCellLink } from '@sequencehq/core-components'

export const ProductLinkCell = ({
  product
}: {
  product: { id: string; name: string } | null | undefined
}) => {
  if (!product) {
    return <MagicTableCell text="No Product" />
  }

  return (
    <MagicTableCellLink to={`/products/${product.id}`} label={product.name} />
  )
}
